// extracted by mini-css-extract-plugin
module.exports = {"legalFooter":"bm_gb","grid":"bm_bK","copyright":"bm_gc","actions":"bm_gd","rrss":"bm_gf","links":"bm_gg","link":"bm_cn","languageSelector":"bm_gh","legalFooterDark":"bm_gj"};